import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import SearchIcon from "@atlaskit/icon/glyph/search";

const searchIconStyle = css({
    "marginInlineStart": "8px",
    "background": "transparent",
    "border": 0,
    "cursor": "pointer",
    "padding": 0,
    "color": "#64686f",
    "&:hover": {
        svg: {
            backgroundColor: "#dfe1e5"
        }
    },
    "svg": {
        color: "#101214",
        borderRadius: "50%",
        height: "auto",
        padding: "5px",
        width: "32px",
        minWidth: "32px"
    }
});

export const SearchButton = () => {
    const intl = useIntl();
    const translated = {
        searchLabel: intl.formatMessage({
            id: "CustomerLandingPage.search.label",
            defaultMessage: "Search"
        })
    };

    return (
        <button
            type="submit"
            css={searchIconStyle}
            id="customer-story-search-icon"
            aria-label={translated.searchLabel}
            data-event="clicked"
            data-event-component="button"
            data-event-container="customerStorySearchButton"
            data-product-key="customer"
        >
            <SearchIcon label={translated.searchLabel} primaryColor="#101214" />
        </button>
    );
};
